<template>
  <b-button :disabled="disabled" :class="buttonClass" :size="size" :variant="variant" @click="onclick">
    <b-spinner style="width: 20px; height: 20px;" variant="light" v-if="isLoading" label="Spinning"></b-spinner>
    <template v-else>{{text}}</template>
  </b-button>
</template>

<script>
export default {
  props: {
    text: String,
    onclick: {
      type:Function,
      default:()=>{}
    },
    variant: String,
    size: String,
    isLoading: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: "simpleBtn"
    },
    disabled:{
        type:Boolean,
        default:false
    }
  }
};
</script>

<style scoped>
.simpleBtn{
    height: 30px;
    min-width: 100px;
}
.loading-img {
  height: 100%;
  width: auto;
}
</style>